// extracted by mini-css-extract-plugin
export default {"root":"_1dq3N","expanded":"u-lvj"};